 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		15: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		15: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"7bc23de15ec3eb68df715500cb66b5dd0826c14d","2":"215156a9446f07201e71d42e2a778485480be15c","3":"2cf658ad83971b66a20a515afce6186db6350b14","4":"44571625eecce49e8f92bfcc51863471a40e5eca","5":"c05b8182","6":"component---src-pages-layout-js","7":"fa0a4f1ca647b7c9a5a90d2b5459c364088a3908","8":"0e1201bb1a37b9e87ddc479f88174b91c37587bc","9":"4ad82c5e","10":"0df6a05716ff351e4e1adb7cf212ed1eeadaa4f1","11":"39a9bd22f798f30931384f4a216a4a26b9ea214f","12":"71b3ce269d1bb16850dca227076689472c051cab","13":"9ce52433c4e6227caea5918fbf2a0935fa2d2a80","14":"a68e81b59c5cb95c03788356a4e9985f75616164","23":"3dcc3d58","34":"c46c4a8f","37":"component---src-pages-404-js","38":"component---src-pages-banner-js","39":"component---src-pages-checkout-simulator-index-tsx","40":"component---src-pages-checkout-simulator-sections-build-tsx","41":"component---src-pages-checkout-simulator-sections-card-generator-tsx","42":"component---src-pages-checkout-simulator-sections-code-tsx","43":"component---src-pages-checkout-simulator-sections-configure-tsx","44":"component---src-pages-checkout-simulator-sections-demo-tsx","45":"component---src-pages-checkout-simulator-sections-help-modal-tsx","46":"component---src-pages-checkout-simulator-sections-know-before-you-code-tsx","47":"component---src-pages-checkout-simulator-sections-preview-tsx","48":"component---src-pages-checkout-simulator-sections-take-live-tsx","49":"component---src-pages-classic-home-js","50":"component---src-pages-docs-template-js","51":"component---src-pages-home-js","52":"component---src-pages-index-js","53":"component---src-pages-integration-builder-index-tsx","54":"component---src-pages-integration-builder-modals-test-experience-modal-tsx","55":"component---src-pages-integration-builder-sections-preview-tsx","56":"component---src-pages-integration-builder-steps-configure-integration-step-tsx","57":"component---src-pages-integration-builder-steps-test-integration-step-tsx","58":"component---src-pages-internal-js","59":"component---src-pages-signup-js","60":"component---src-pages-signupauto-js","61":"component---src-pages-support-js","62":"component---src-pages-thankyou-js","63":"component---src-pages-unsubscribe-js","64":"component---src-templates-template-layout-js","68":"d7eeaac4"}[chunkId]||chunkId) + "-" + {"0":"407fe62976dc5310c43e","1":"35fd58c53936d17cb11d","2":"1e55f5887d628235b6dc","3":"f969cecc5abd4319b0f2","4":"09c381cf589622b32ca8","5":"dfe96745860dd87c0b8d","6":"02df4082fe23b9bf57ea","7":"1b8b2e41aaac0262a41c","8":"690dd50bc2780ad3262a","9":"c6a514d01d2e2d483bba","10":"bdef5d61c748676261a7","11":"b449f072b7b8d19a28ae","12":"f2c0fdac18821394b5a9","13":"e7a8d171f3989749e088","14":"d63ed1bfc0b45611c81c","23":"07a764d294ad9c4708e9","34":"4e8884f1788cc75dfd6c","37":"b5f9332c85662f143674","38":"c37c8967ea709bc5823b","39":"71e88561ccb0b2fe60c1","40":"74933362dc864d132560","41":"f2ac11955943ae1964cd","42":"8964fcd7078742ac924b","43":"a30c4b92e25647d89c7e","44":"6c93beebd4850f35981b","45":"9a3803e07ca3ca5ca296","46":"2715c18d50b317781e73","47":"bbc5d756f13fe2efaa8f","48":"c0266f374252a7e51492","49":"af124f0640dba0cd9635","50":"4dad7aee4e539ff78945","51":"06c68ca1515ae656a82b","52":"2b8f260e4d71f56f31c3","53":"d4e7c85e94f55cf99845","54":"ecbef467c71425a4687c","55":"139867c162010409eb11","56":"b6805e46465c9304beec","57":"b1e55772ee353b5d974f","58":"68892beab2daef66725b","59":"7f467b765adf23ed27d8","60":"4f86b541fe094e8e3620","61":"c0d146ed80c348e1b8a0","62":"d42b1810e5fd38b487a5","63":"f96159f221e8ed57c382","64":"2ada87f4b6d2cb4ad847","68":"7d37e9e102687140824d","73":"cd02d6122dd1a278cded"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"7bc23de15ec3eb68df715500cb66b5dd0826c14d","2":"215156a9446f07201e71d42e2a778485480be15c","3":"2cf658ad83971b66a20a515afce6186db6350b14","4":"44571625eecce49e8f92bfcc51863471a40e5eca","5":"c05b8182","6":"component---src-pages-layout-js","7":"fa0a4f1ca647b7c9a5a90d2b5459c364088a3908","8":"0e1201bb1a37b9e87ddc479f88174b91c37587bc","9":"4ad82c5e","10":"0df6a05716ff351e4e1adb7cf212ed1eeadaa4f1","11":"39a9bd22f798f30931384f4a216a4a26b9ea214f","12":"71b3ce269d1bb16850dca227076689472c051cab","13":"9ce52433c4e6227caea5918fbf2a0935fa2d2a80","14":"a68e81b59c5cb95c03788356a4e9985f75616164","23":"3dcc3d58","34":"c46c4a8f","37":"component---src-pages-404-js","38":"component---src-pages-banner-js","39":"component---src-pages-checkout-simulator-index-tsx","40":"component---src-pages-checkout-simulator-sections-build-tsx","41":"component---src-pages-checkout-simulator-sections-card-generator-tsx","42":"component---src-pages-checkout-simulator-sections-code-tsx","43":"component---src-pages-checkout-simulator-sections-configure-tsx","44":"component---src-pages-checkout-simulator-sections-demo-tsx","45":"component---src-pages-checkout-simulator-sections-help-modal-tsx","46":"component---src-pages-checkout-simulator-sections-know-before-you-code-tsx","47":"component---src-pages-checkout-simulator-sections-preview-tsx","48":"component---src-pages-checkout-simulator-sections-take-live-tsx","49":"component---src-pages-classic-home-js","50":"component---src-pages-docs-template-js","51":"component---src-pages-home-js","52":"component---src-pages-index-js","53":"component---src-pages-integration-builder-index-tsx","54":"component---src-pages-integration-builder-modals-test-experience-modal-tsx","55":"component---src-pages-integration-builder-sections-preview-tsx","56":"component---src-pages-integration-builder-steps-configure-integration-step-tsx","57":"component---src-pages-integration-builder-steps-test-integration-step-tsx","58":"component---src-pages-internal-js","59":"component---src-pages-signup-js","60":"component---src-pages-signupauto-js","61":"component---src-pages-support-js","62":"component---src-pages-thankyou-js","63":"component---src-pages-unsubscribe-js","64":"component---src-templates-template-layout-js","68":"d7eeaac4"}[chunkId]||chunkId) + "." + {"0":"22e87296f1d7b3b6e401","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c","68":"31d6cfe0d16ae931b73c","73":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://www.paypalobjects.com/ppdevdocs/v1/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
